import { render, staticRenderFns } from "./ActionFormSetup.vue?vue&type=template&id=51bf3f4a&scoped=true&"
import script from "./ActionFormSetup.vue?vue&type=script&lang=js&"
export * from "./ActionFormSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf3f4a",
  null
  
)

export default component.exports